import { render, staticRenderFns } from "./QuizUser.vue?vue&type=template&id=7037f68e&scoped=true"
import script from "./QuizUser.vue?vue&type=script&lang=js"
export * from "./QuizUser.vue?vue&type=script&lang=js"
import style0 from "./QuizUser.vue?vue&type=style&index=0&id=7037f68e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7037f68e",
  null
  
)

export default component.exports